import dfpApi from '../common/api/googleIntegrationApi';

const basePath = '/dfp';

function getGoogleAuthUrl() {
  const baseRedirectUrl = window.location.origin;
  const oauth2BaseUrl = 'https://accounts.google.com/o/oauth2/auth';
  const accessType = 'offline'; // Gets a refresh token.
  const prompt = 'consent';
  const scopeEncoded = encodeURIComponent('https://www.googleapis.com/auth/dfp https://www.googleapis.com/auth/doubleclickbidmanager');
  const responseType = 'code';
  const clientId = process.env.GOOGLE_INTEGRATION_CLIENT_ID;
  const redirectUrlEncoded = encodeURIComponent(`${baseRedirectUrl}/google/OAuthCallback`);
  return `${oauth2BaseUrl}?access_type=${accessType}&prompt=${prompt}&scope=${scopeEncoded}&response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUrlEncoded}`;
}

function generateSizesForTag(adUnit) {
  const adUnitSizes = adUnit.adUnitSizes;
  const sizes = adUnitSizes ? adUnitSizes.map(adUnitSize => `${adUnitSize.size.width}x${adUnitSize.size.height}`) : [];
  return sizes.length > 0 ? sizes.join(',') : '640x480';
}

export default {
  authenticateWithGoogle() {
    const googleAuthUrl = getGoogleAuthUrl();
    const width = 600;
    const height = 400;
    const left = (window.screen.width / 2) - ((width / 2));
    const top = (window.screen.height / 2) - ((height / 2));
    return window.open(googleAuthUrl, 'Google Authentication', `width=${width},height=${height},left=${left},top=${top},modal=yes,alwaysRaised=yes`);
  },
  getNetworks() {
    return dfpApi.post(`${basePath}/getNetworks`, {});
  },
  getAdvertisers(networkCode) {
    return dfpApi.post(`${basePath}/getAdvertisers`, JSON.stringify({ network: networkCode }));
  },
  getAdvertiserOrders(networkCode, advertiserId) {
    return dfpApi.post(`${basePath}/getCampaigns`, JSON.stringify({ network: networkCode, advertiserId }));
  },
  getOrderLineItems(networkCode, orderId) {
    return dfpApi.post(`${basePath}/getLineItems`, JSON.stringify({ network: networkCode, orderId }));
  },
  getLineItemAdUnits(networkCode, lineItemId) {
    return dfpApi.post(`${basePath}/getAdUnits`, JSON.stringify({ network: networkCode, lineItemId }));
  },
  oauthCallback(code, redirectUri) {
    return dfpApi.get(`oauthcallback?code=${code}&redirectUri=${redirectUri}`);
  },
  buildVastTag(networkCode, adUnit) {
    const vTagBaseUrl = 'https://pubads.g.doubleclick.net/gampad/ads';
    const defaultQueryString = 'impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=[referrer_url]&description_url=[description_url]&correlator=[timestamp]';
    return `${vTagBaseUrl}?${defaultQueryString}&sz=${generateSizesForTag(adUnit)}&iu=/${networkCode}/${adUnit.adUnitCode}`;
  }
};



// WEBPACK FOOTER //
// ./src/services/dfpService.js